import { redirect } from 'react-router-dom';
import Cookies from 'js-cookie';

export const checkCreator = () => {
  const token = Cookies.get(`token`);

  if (!token) {
    window.location.href = '/authen/login';
    return redirect('/');
  }

  // Check if user is a creator
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      if (!user.isCreator) {
        // Redirect to home if not a creator
        window.location.href = '/';
        return redirect('/');
      }
    } catch (e) {
      console.error('Error parsing user data:', e);
    }
  }

  return null;
};

